import { Component, Input, OnChanges, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { LanguageTranslatePopup } from '../popup/language-translate/language-translate.popup';
import { MatDialog } from '@angular/material';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { MenuAttachmentModel } from '../../models/menu-attachment.model';
import { CatalogCategory, CatalogueService } from '../../../provider/catalogue.service';
import { Subscription } from 'rxjs';
import { MenuItemCatalogGroupModel } from '../../models/menu-item-catalog-group.model';
import { MenuItemCatalogModel } from '../../models/menu-item-catalog.model';
import { MenuItemCatalogPriceModel } from '../../models/menu-item-catalog-price.model';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import { ItemCatalogPopup } from '../popup/item-catalog/item-catalog.popup';
import { TranslateModel } from '../../../core/_base/layout/models/translate.model';
import { ItemService } from '../../../provider/item.service';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from '../../../provider/translation.service';
import { AppHotelService } from '../../../provider/app-hotel.service';
import { UserService } from '../../../provider/user.service';
import { AppHotelModel } from '../../models/app-hotel.model';
import { AWSService } from '../../../provider/aws.service';
import { UserModel } from '../../models/user.model';
import { PrinterService } from 'src/app/provider/printer.service';
import { PrinterSetup } from '../../models/printer.model';

@Component({
  selector: 'c-catalogue',
  templateUrl: './catalogue.component.html',
  styleUrls: ['./catalogue.component.scss']
})
export class CatalogueComponent implements OnChanges, OnDestroy {
  @Input() ID: number;
  product: any;
  newCategory = { name: '', priority: 1 };
  fileToUpload: File = null;
  hotelNo = JSON.parse(localStorage.getItem('token_form')).app_hotel_id;
  profile: UserModel = JSON.parse(localStorage.getItem('token_form'));

  currentMenuAttachment: MenuAttachmentModel;
  currentMenuItemCatalog: MenuItemCatalogModel;
  currentMenuItemCatalogPrice: MenuItemCatalogPriceModel;
  currentMenuItemCatalogGroupModel: MenuItemCatalogGroupModel;

  subs: Subscription[] = [];

  filterQuery: string = null;

  time: number = new Date().getTime();

  newImage: any = null;
  newImageFile: File = null;
  uploaded = true;
  popupVisible = false;

  constructor(
    public dialog: MatDialog,
    public myService: CatalogueService,
    public tra: TranslationService,
    public itemService: ItemService,
    public translate: TranslateService,
    private hotelService: AppHotelService,
    private userService: UserService,
    private awsService: AWSService,
    public printerServ: PrinterService,
    private changeDetector: ChangeDetectorRef
  ) {
  }

  async ngOnChanges(changes: { [propKey: string]: any }) {
    this.ID = +changes.ID.currentValue;
    this.myService.getData(this.ID);

    await this.printerServ.getPrinters();
    await this.printerServ.getSetups();
    console.log(this.printerServ.printers);

    // this.itemService.getData(this.ID, 'item-catalog-image', 'image');
  }

  ngOnDestroy() {
    for (const item of this.subs) {
      item.unsubscribe();
    }
  }

  drop(event: CdkDragDrop<string[]>, items: MenuItemCatalogModel[], indexDatas: number) {
    const currentIndex = event.currentIndex;
    const previousIndex = event.previousIndex;
    if (currentIndex == previousIndex) {
      return;
    }
    items[previousIndex].priority = items[currentIndex].priority;
    if (currentIndex > previousIndex) {
      for (let i = previousIndex; i < currentIndex; i++) {
        items[i + 1].priority = items[i + 1].priority - 1;
      }
    } else {
      for (let i = currentIndex; i < previousIndex; i++) {
        items[i].priority = items[i].priority + 1;
      }
    }
    const datas = this.myService.record_change$.getValue();
    datas[indexDatas].items = items;
    datas[indexDatas].items.forEach(x => {
      this.myService.putCatalogData(x);
    });
    this.myService.setDatas(datas);
  }

  async updatePrinter(id: number, printerIndex: number) {
    const PRINTER = this.printerServ.printers[printerIndex];

    if (PRINTER) {
      const NEWSETUP = new PrinterSetup();
      NEWSETUP.hotel_id = this.profile.app_hotel_id;
      NEWSETUP.printer_id = PRINTER.id;
      NEWSETUP.report_name = 'kitchen';
      NEWSETUP.table_name = 'menu-item-catalog-group';
      NEWSETUP.table_record_id = id;

      const EXIST = this.printerServ.setups.find(x => x.table_record_id === id);

      if (EXIST) {
        NEWSETUP.id = EXIST.id;
        await this.printerServ.postSetup(NEWSETUP);
      } else {
        await this.printerServ.postSetup(NEWSETUP);
      }

    } else {
      const SETUP = this.printerServ.setups.find(x => x.table_record_id === id);
      await this.printerServ.deleteSetup(SETUP.id);
    }
  }

  setPriority(event, array: CatalogCategory[]) {
    console.log(event);
    const isMinus = event.currentIndex - event.previousIndex < 0;

    if (isMinus) {
      for (let i = event.previousIndex; i > event.currentIndex; i--) {
        [array[i], array[i - 1]] = [array[i - 1], array[i]];
      }
    } else {
      for (let i = event.previousIndex; i < event.currentIndex; i++) {
        [array[i], array[i + 1]] = [array[i + 1], array[i]];
      }
    }

    for (let i = 0; i < array.length; i++) {
      array[i].category.priority = i + 1;
      this.myService.putCatalogGroup(array[i].category);
    }
  }

  multiColDrop(event: CdkDragDrop<any>, index: number) {

    const DATA = this.myService.record_change$.getValue();

    DATA[index].items[event.previousContainer.data.index] = event.container.data.item;
    DATA[index].items[event.container.data.index] = event.previousContainer.data.item;

    DATA[index].items.forEach((item, catIndex) => {
      item.priority = catIndex + 1;
      this.myService.putCatalogData(item);
    });
    this.myService.setDatas(DATA);
  }

  changePriority(array: CatalogCategory[]) {

    let TEMP: CatalogCategory[] = JSON.parse(JSON.stringify(array));

    TEMP = TEMP.sort((a, b) => a.category.priority - b.category.priority);


    for (let i = 0; i < TEMP.length; i++) {
      array[i] = TEMP[i];
      array[i].category.priority = i + 1;
      this.myService.putCatalogGroup(array[i].category);
    }

  }

  changeCategory(dataID: number, oldCategoryID: number, newcategoryID: number) {
    const datas = this.myService.record_change$.getValue();
    const data = datas[oldCategoryID].items[dataID];
    const newCategory = datas[newcategoryID];
    if (newCategory.items.length > 0) {
      const sortData = newCategory.items.sort((a, b) => a.priority - b.priority);
      data.priority = sortData[sortData.length - 1].priority + 1;
    } else {
      data.priority = 1;
    }
    data.menu_item_catalog_group_id = newCategory.category.id;
    this.myService.putCatalogData(data);
    datas[newcategoryID].items.push(data);
    datas[oldCategoryID].items.splice(dataID, 1);
    this.myService.setDatas(datas);
  }

  deleteProduct(i: number, j: number) {
    const priceDatas = this.myService.price_change$.getValue();
    const datas = this.myService.record_change$.getValue();

    this.awsService.getImages(this.userService.record_change$.getValue().app_hotel_id, 'Item Catalog', datas[i].items[j].id);
    for (const img of this.awsService.catalogImage_change$.getValue()) {
      console.log('Burdayım');
      this.awsService.deleteImage(this.userService.record_change$.getValue().app_hotel_id, 'Item Catalog', img.file_name).subscribe();
    }
    const priceIndex = priceDatas.findIndex(x => x.menu_item_catalog_id == datas[i].items[j].id);
    this.myService.deleteCatalogData(datas[i].items[j]);
    this.myService.deleteCatalogPrice(priceDatas[priceIndex].id);
  }

  async Save() {
    const NEW: MenuItemCatalogGroupModel = new MenuItemCatalogGroupModel(0, this.ID, this.newCategory.name);
    NEW.priority = this.newCategory.priority;
    await this.myService.postCatalogGroup(NEW);
    await this.myService.getData(this.ID);
    const GROUPS: MenuItemCatalogGroupModel[] = await this.myService.getDataPromise(this.ID);
    const ORDERED = this.myService.record_change$.getValue().sort((a, b) => a.category.priority - b.category.priority);

    for (let i = 0; i < ORDERED.length; i++) {
      ORDERED[i].category.priority = i + 1;
      this.myService.putCatalogGroup(ORDERED[i].category);
    }

    this.myService.record_change$.next(ORDERED);


    const ID = GROUPS.find(x => x.name === NEW.name).id;


    if (this.newImage) {
      this.uploaded = false;
      this.changeDetector.detectChanges();

      const reader = new FileReader();
      reader.readAsDataURL(this.newImageFile);
      reader.onload = () => {
        const format = this.newImageFile.type.split('/')[1];
        const imageName = `${ID}.${format}`;
        this.awsService.uploadImage(this.newImageFile, this.profile.app_hotel_id, 'CatalogGroups', imageName).subscribe((resp: any) => {
          this.newImageFile = null;
          this.newImage = null;
          this.uploaded = true;
          this.myService.getData(this.ID);
          this.changeDetector.detectChanges();
          setTimeout(() => {
            const CARD = document.getElementById(`card-${ID}`);
            CARD.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center'
            });
          }, 500);
          this.newCategory = { name: null, priority: 0 };
          this.popupVisible = false;
        });
      };
    } else {
      setTimeout(() => {
        const CARD = document.getElementById(`card-${ID}`);
        CARD.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        });
      }, 500);
      this.popupVisible = false;
      this.newCategory = { name: null, priority: 0 };
    }

  }

  languageTranslate(baseData: any, key: string, val: string, baseDataType?: string) {
    let translateModel: TranslateModel;
    try {
      translateModel = JSON.parse(val);
    } catch (e) {
      translateModel = new TranslateModel();
    }
    if (baseDataType == 'MenuAttachment') {
      this.currentMenuAttachment = baseData;
    } else {
      this.currentMenuAttachment = undefined;
    }
    if (baseDataType == 'MenuItemCatalogPrice') {
      this.currentMenuItemCatalogPrice = baseData;
    } else {
      this.currentMenuItemCatalogPrice = undefined;
    }

    if (baseDataType == 'MenuItemCatalog') {
      this.currentMenuItemCatalog = baseData;
    } else {
      this.currentMenuItemCatalog = undefined;
    }
    if (baseDataType == 'MenuItemCatalogGroupModel') {
      this.currentMenuItemCatalogGroupModel = baseData;
    } else {
      this.currentMenuItemCatalogGroupModel = undefined;
    }

    const dialogRef = this.dialog.open(LanguageTranslatePopup, {
      width: '700px', data: {
        ML: translateModel,
        baseData,
        key,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      // this.itemService.putItem(this.data);
      if (this.currentMenuAttachment != undefined) {
        this.myService.putPdf(this.currentMenuAttachment);
      }
      if (this.currentMenuItemCatalog != undefined) {
        this.myService.putCatalogData(this.currentMenuItemCatalog);
      }
      if (this.currentMenuItemCatalogPrice != undefined) {
        this.myService.putPriceData(this.currentMenuItemCatalogPrice);
      }
      if (this.currentMenuItemCatalogGroupModel != undefined) {
        this.myService.putCatalogGroup(this.currentMenuItemCatalogGroupModel);
      }
    });
  }

  editProduct(data: MenuItemCatalogModel) {
    const dialogRef = this.dialog.open(ItemCatalogPopup, { data, width: '1400px' });

    dialogRef.afterClosed().subscribe(() => {
      this.myService.getData(this.ID);
    });
  }

  Delete(i: number) {
    const datas = this.myService.record_change$.getValue();
    if (datas.length <= 0) {
      console.log('silinemez');
      return;
    }
    if (datas[i].items.length > 0) {
      for (const item of datas[i].items) {
        if (i == 0) {
          item.menu_item_catalog_group_id = datas[1].category.id;
          item.priority = datas[1].items.length + 1;
          datas[1].items.push(item);
        } else {
          item.menu_item_catalog_group_id = datas[0].category.id;
          item.priority = datas[0].items.length + 1;
          datas[0].items.push(item);
        }
        this.myService.putCatalogData(item);
      }
    }
    this.myService.deleteCatalogGroup(datas[i].category);
  }

  addPdfLine() {
    const pdfLines: MenuAttachmentModel[] = this.myService.pdf_change$.getValue();
    const pdfLine = new MenuAttachmentModel();
    pdfLine.table_name = 'item-catalog-pdf';
    pdfLine.table_record_id = this.ID;
    pdfLine.type = 'pdf';
    if (pdfLines.length == 0) {
      pdfLine.priority = 1;
    } else {
      pdfLine.priority = pdfLines[pdfLines.length - 1].priority + 1;
    }
    pdfLines.push(pdfLine);
    this.myService.pdf_change$.next(pdfLines);
  }

  deletePdfLine(item: MenuAttachmentModel, i) {
    const pdfDatas = this.myService.pdf_change$.getValue();
    if (pdfDatas[i].id == 0) {
      pdfDatas.splice(i, 1);
      return;
    }
    this.myService.deleteAttachment(item);
    pdfDatas.splice(i, 1);
  }

  handleFileInput(i: number, files: FileList, event: any) {
    this.fileToUpload = files.item(0);
    if (event.target.files && event.target.files.length > 0) {
      for (const file of event.target.files) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const pdf = new MenuAttachmentModel(
            1, 'item-catalog-pdf', 'pdf', 1,
            reader.result.toString(), 1, file.name, '');
          const pdfDatas = this.myService.pdf_change$.getValue();
          pdfDatas[i].name = file.name;
          this.myService.postFile(file);
        };
      }
    }
  }

  getPriceData(id: number): MenuItemCatalogPriceModel {
    const priceDatas = this.myService.price_change$.getValue();
    const data = priceDatas.find(x => x.menu_item_catalog_id == id);
    if (isNotNullOrUndefined(data)) {
      return data;
    } else {
      return new MenuItemCatalogPriceModel();
    }
  }

  addNewItemLine(i: number) {
    const datas = this.myService.record_change$.getValue();
    const catalogItem: MenuItemCatalogModel = new MenuItemCatalogModel(0, this.ID, datas[i].category.id, datas[i].items.length + 1, '', '', [], '', '',new Date(), new Date(),0,'','',0);
    this.myService.postData(catalogItem).subscribe(
      (resp: MenuItemCatalogModel) => {
        this.hotelService.getHotelInfo(this.userService.record_change$.getValue().app_hotel_id).subscribe(
          (hotel: AppHotelModel) => {
            this.myService.postPriceData(new MenuItemCatalogPriceModel(0, this.ID, resp.id, 0, '',
              false, 0, '', hotel.currency_code)).subscribe(
                () => {
                  this.myService.getData(this.ID);

                  const dialogRef = this.dialog.open(ItemCatalogPopup, { data: resp, width: '1400px' });
                  dialogRef.afterClosed().subscribe(result => {
                    this.myService.getData(this.ID);
                  });
                }
              );
          }
        );
      }
    );
  }

  changeCurrency(item: MenuItemCatalogModel, value: string) {
    const priceDatas = this.myService.price_change$.getValue();
    const data = priceDatas.find(x => x.menu_item_catalog_id == item.id);
    if (!isNotNullOrUndefined(data)) {
      this.myService.postPriceData(new MenuItemCatalogPriceModel(0, item.menu_item_id, item.id, 0, '', false, 0, '', value)).subscribe(
        () => {
        },
        (err) => console.log(err),
        () => this.myService.getData(item.menu_item_id)
      );
    } else {
      data.currency_code = value;
      this.myService.putPriceData(data);
    }
  }

  newCategoryImage(image: HTMLInputElement) {
    if (image.files && image.files.length > 0) {
      const reader = new FileReader();
      this.newImageFile = image.files[0];
      reader.readAsDataURL(image.files[0]);
      reader.onload = () => {
        this.newImage = reader.result;
        this.changeDetector.detectChanges();
      }
    }
  }

  uploadCategoryImage(image: any, catalog: MenuItemCatalogGroupModel, imageLogo: HTMLElement, spinner: HTMLElement, background: HTMLElement) {
    if (image.files && image.files.length > 0) {
      spinner.classList.remove('d-none');
      spinner.classList.add('d-flex');
      imageLogo.classList.add('d-none');

      this.changeDetector.detectChanges();

      const reader = new FileReader();
      reader.readAsDataURL(image.files[0]);
      reader.onload = () => {
        const format = image.files[0].type.split('/')[1];
        const imageName = `${catalog.id}.${format}`;

        this.awsService.uploadImage(image.files[0], this.profile.app_hotel_id, 'CatalogGroups', imageName).subscribe((resp: any) => {
          catalog.priority = catalog.priority ? catalog.priority : 1;
          this.myService.putCatalogGroup(catalog);

          spinner.classList.add('d-none');
          spinner.classList.remove('d-flex');
          imageLogo.classList.remove('d-none');
          this.myService.getData(this.ID);

          this.changeDetector.detectChanges();
        });
      };
    }
  }

  openEditHeader(editDiv: HTMLElement, displayDiv: HTMLElement) {
    editDiv.classList.remove('d-none');
    displayDiv.classList.add('d-none');
    displayDiv.classList.remove('d-flex');
  }
}
